<mat-dialog-content>
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
    <div class="bg-white max-w-lg w-full rounded-xl shadow-xl p-6 md:p-8 relative">
      <h2 class="text-base font-medium mb-6">Форма обратной связи</h2>
      <form [formGroup]="messageForm" class="space-y-5 p-4" style="background: #F5F5F5; border-radius: 10px;">
        <div>
          <label class="block text-sm mb-1" style="color: #3C3C40">
            Ваше имя <span class="text-red-500">*</span>
          </label>
          <input
            type="text"
            formControlName="name"
            class="w-full border border-gray-300  px-3 py-2 focus:outline-none focus:border-gray-500"
          />
        </div>

        <div>
          <label class="block text-sm mb-1" style="color: #3C3C40">
            Номер телефона или email <span class="text-red-500">*</span>
          </label>
          <input
            type="text"
            formControlName="emailPhone"
            class="w-full border border-gray-300  px-3 py-2 focus:outline-none focus:border-gray-500"
          />
          <p class="text-xs text-gray-500 mt-1">
            Номер телефона в формате +0 от 11-ти до 13-ти символов
          </p>
        </div>

        <div>
          <label class="block mb-1" style="color: #3C3C40">Ваше сообщение
            <span class="text-red-500">*</span>
          </label>
          <textarea
            formControlName="comment"
            placeholder="Введите сообщение"
            class="w-full border border-gray-300  px-3 py-2 min-h-[120px] resize-none focus:outline-none focus:border-red-500"
          ></textarea>
        </div>

        <div class="p-4 flex items-center gap-4">
          <div class="flex items-center gap-2">
            <div class="transform origin-left scale-90 sm:scale-100">
              <re-captcha
                (resolved)="resolved($event)"
                [size]="'normal'"
                [siteKey]="publicKey"
                #reCaptcha
              ></re-captcha>
            </div>
          </div>
        </div>


        <div class="flex flex-col sm:flex-row items-center justify-between mt-6 gap-4">
          <button
            [disabled]="messageForm.invalid"
            (click)="sendMessage()"
            type="submit"
            class="
    px-[22px] py-[8px] text-[16px] rounded-[4px] cursor-pointer
    border bg-custom-red text-white
    hover:border-custom-red hover:text-custom-red hover:bg-transparent
    transition-all duration-200
    w-full sm:w-auto
disabled:opacity-50 disabled:hover:none disabled:cursor-not-allowed disabled:pointer-events-none

  ">
            Отправить
          </button>


          <a
            (click)="close()"
            type="button"
            class="text-blue-500 hover:underline"
          >
            Назад
          </a>
        </div>
      </form>
    </div>
  </div>
</mat-dialog-content>


